import { LitElement } from "lit-element";
import { html, render } from "lit-html";
import PubSub from "pubsub-js";
import { storeInstance } from "../../store/index";

class Ipc3dTable extends LitElement {
  constructor() {
    super();
    this.ipc = {};
  }

  parseTable() {
    this.ipc.table = this.ipcTable;

    // assumes that an IPC topic will only ever contain a single table
    // the class tbody comes from the OT by default
    this.ipc.tbody = this.ipcTable.querySelector(".tbody");
    this.ipc.thead = this.ipcTable.querySelector(".thead");
    // var nullRows = [];
    var caption = this.ipcTable.querySelector("caption");
    if (caption) {
      caption.innerHTML = "";
    }

    var th = document.createElement("th");
    th.innerHTML = "Order";
    th.setAttribute("class", "entry cellrowborder");
    th.setAttribute("style", "vertical-align: top;");
    this.ipc.thead.children[0].appendChild(th);
    // hide Index cell here
    this.ipc.thead.children[0].children[0].classList.add("index-col-hidden")

    // create table rows
    for (var i = 0; i < this.ipc.tbody.children.length; i++) {
      var row = this.ipc.tbody.children[i];
      var a_rowId = row.getAttribute("id").split("_");
      var coid = a_rowId[a_rowId.length - 1];
      if (row.children[0].innerText == "null") {
        row.children[0].innerText = "n/a";
      }
      var item = {};
      item.coid = coid;
      item.title = "table title";
      item.indexNum = row.cells[0].innerText;
      item.partno = row.cells[1].innerText;
      item.description = row.cells[2].innerText;
      row.setAttribute("item", JSON.stringify(item));
      row.setAttribute("coid", item.coid);
      row.setAttribute("index-num", item.indexNum);

      if (row.children[0].innerText != "n/a") {
        row.classList.add("datarow");
        row.addEventListener("click", this.onRowClick);
      } else {
        row.classList.add("narrow");
      }

      // can probably hide index cells here
      row.children[0].classList.add('index-col-hidden')

      var td = document.createElement("td");

      if (item.indexNum.trim() != "") {
        var btn = document.createElement("div");
        // var icon = document.createElement("iron-icon");

        btn.innerHTML = "Add to cart";
        btn.setAttribute("class", "orderbtn");
        item.title = "TITLE";
        btn.setAttribute("item", JSON.stringify(item));
        btn.addEventListener("click", this.onOrderButtonClick);
        // set width of order column
        td.classList.add("order-col-width")
        td.appendChild(btn);
      }
      row.appendChild(td);
    }
    return this.ipc.table;
  }

  onOrderButtonClick(e) {
    var item = JSON.parse(e.currentTarget.getAttribute("item"));
    storeInstance.dispatch("addOrderItem", item)
  }

  onRowClick() {
    const partId = this.children[0].innerText;
    console.log("debug onRowClick, partId: ", partId)
    if (this.classList.contains("ipc-table-row-selected")) {
      PubSub.publish("deselectRow", partId);
      this.classList.remove("ipc-table-row-selected");
    } else {
      PubSub.publish("selectRow", partId);
      this.classList.add("ipc-table-row-selected");
    }
  }

  createSubscriptions() {
    PubSub.subscribe("selectPartKey", (msg, partKey) => {
      const cells = this.shadowRoot.querySelectorAll("td");
      cells.forEach(cell => {
        if (cell.innerText === partKey) {
          console.log(cell.parentElement);
          cell.parentElement.classList.add("ipc-table-row-selected");
        }
      });
    });
    PubSub.subscribe("deselectPartKey", (msg, partKey) => {
      const cells = this.shadowRoot.querySelectorAll("td");
      cells.forEach(cell => {
        if (cell.innerText === partKey) {
          console.log(cell.parentElement);
          cell.parentElement.classList.remove("ipc-table-row-selected");
        }
      });
    });
  }

  connectedCallback() {
    this.parseTable();
    this.createSubscriptions();
    this.myRender();
  }

  myRender() {
    render(
      html`
        <style>
          table {
            border-collapse: separate;
            width: 100%;
            font-family: Roboto;
          }
          table th {
            padding: 10px 20px;
          }
          table td {
            padding: 8px 16px;
          }
          table th {
            border: 1px solid #000;
          }

          th.entry {
            top: 0;
            background-color: #eee;
          }
          .PNGPartsTable th {
            position: sticky;
            top: 0;
          }
          .PNGPartsTable {
            font-size: 1em;
            background-color: transparent;
          }
          .PNGPartsTable tbody tr.datarow {
            cursor: pointer;
          }
          .PNGPartsTable tbody tr.narrow {
            background-color: #e0e0e0;
            cursor: not-allowed;
          }
          .ipc-table-row-selected {
            background-color: #c4e3ff;
            /* background-color: #c4e3ff; */
          }
        .index-col-hidden {
            display: none;
          }
          .order-col-width {
            width: 100px;
          }
        </style>
        <div>
          ${this.ipc.table}
        </div>
      `,
      this.shadowRoot
    );
  }
}

customElements.define("ipc-3d-table", Ipc3dTable);
